import {CustomCssVarsFn} from '@wix/yoshi-flow-editor'

import {
  StylesParamsType,
  AlignmentToTextAlign,
  AlignmentToAlignItems,
  ImageSizeToBackgroundSize,
} from '../../types/createStylesParams'
import {
  imageStylesParams,
  ImageStylesParams,
} from '../../components-shared/Settings/Image/stylesParams'

import {layoutStylesParams, LayoutStylesParams} from './Settings/Tabs/Layout/stylesParams'
import {
  textStylesParams,
  TextStylesParams,
} from '../ExperiencesList/Settings/Tabs/Design/Text/stylesParams'
import {
  locationTabsStylesParams,
  LocationTabsStylesParams,
} from '../ExperiencesList/Settings/Tabs/Design/LocationTabs/stylesParams'
import {
  buttonStylesParams,
  ButtonStylesParams,
} from '../ExperiencesList/Settings/Tabs/Design/Button/stylesParams'
import {
  backgroundAndBordersStylesParams,
  BackgroundAndBordersStylesParams,
} from '../ExperiencesList/Settings/Tabs/Design/BackgroundAndBorders/stylesParams'

export type StylesParams = LayoutStylesParams &
  TextStylesParams &
  LocationTabsStylesParams &
  ImageStylesParams &
  ButtonStylesParams &
  BackgroundAndBordersStylesParams

export const stylesParams: StylesParamsType<StylesParams> = {
  ...layoutStylesParams,
  ...textStylesParams,
  ...locationTabsStylesParams,
  ...imageStylesParams,
  ...buttonStylesParams,
  ...backgroundAndBordersStylesParams,
}

export default stylesParams

export const customCssVars: CustomCssVarsFn = ({styleParams}) => {
  const numbers = styleParams.numbers

  return {
    titleAlignment: AlignmentToTextAlign[numbers.titleAlignment],
    experienceTextAlignment: AlignmentToTextAlign[numbers.experienceTextAlignment],
    experienceButtonAlignment: AlignmentToAlignItems[numbers.experienceButtonAlignment],
    experienceImageSize: ImageSizeToBackgroundSize[numbers.experienceImageSize],
  }
}
